import { jsx as _jsx } from "react/jsx-runtime";
import PageContainer from "../common_components/PageContainer";
import CenteredPageName from "../common_components/CenteredPageName";
export default function Profile() {
    return (_jsx(PageContainer, { children: _jsx(CenteredPageName, { title: "Profile" }) }));
}
